import React from "react";

const Cart = () => {
  return (
    <>
      <div className="tf-page-title">
        <div className="container-full">
          <div className="heading text-center">Shopping Cart</div>
        </div>
      </div>
      <section className="flat-spacing-11">
        <div className="container">
          <div className="tf-page-cart-wrap">
            <div className="tf-page-cart-item">
              <table className="tf-table-page-cart">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="tf-cart-item file-delete">
                    <td className="tf-cart-item_product">
                      <a
                        href="https://uat.webykw.com/product/v-neck-cardigan-5"
                        className="img-box"
                      >
                        <img
                          src="https://imgcdn.webykw.com/cdn-cgi/image/fit=cover,width=80,height=110/lolia/products/1726330315_b964d4dba25069fb.jpg"
                          alt="V-Neck Cardigan"
                        />
                      </a>
                      <div className="cart-info">
                        <a
                          href="https://uat.webykw.com/product/v-neck-cardigan-5"
                          className="cart-title link"
                        >
                          V-Neck Cardigan
                        </a>
                        <div className="cart-meta-variant">
                          Color: Off-White
                          <br />
                          Size: XS
                          <br />
                          Add Length Details: 1
                        </div>
                        <span
                          className="remove-cart link remove"
                          onClick="remove('47d74f9094122c6e2966d556b64a43bb','2')"
                        >
                          Remove
                        </span>
                      </div>
                    </td>
                    <td className="tf-cart-item_price" cart-data-title="Price">
                      <div className="cart-price">KWD 10.410 </div>
                    </td>
                    <td
                      className="tf-cart-item_quantity"
                      cart-data-title="Quantity"
                    >
                      <div className="cart-quantity">
                        <div className="wg-quantity">
                          <span
                            className="btn-quantity"
                            id="down_47d74f9094122c6e2966d556b64a43bb"
                            onClick="checkQty('down','47d74f9094122c6e2966d556b64a43bb')"
                          >
                            <svg
                              className="d-inline-block"
                              width="9"
                              height="1"
                              viewBox="0 0 9 1"
                              fill="currentColor"
                            >
                              <path d="M9 1H5.14286H3.85714H0V1.50201e-05H3.85714L5.14286 0L9 1.50201e-05V1Z"></path>
                            </svg>
                          </span>
                          <input
                            type="text"
                            id="qty47d74f9094122c6e2966d556b64a43bb"
                            value="1"
                            max="11"
                            readonly
                          />
                          <span
                            className="btn-quantity"
                            id="up_47d74f9094122c6e2966d556b64a43bb"
                            onClick="checkQty('up','47d74f9094122c6e2966d556b64a43bb')"
                          >
                            <svg
                              className="d-inline-block"
                              width="9"
                              height="9"
                              viewBox="0 0 9 9"
                              fill="currentColor"
                            >
                              <path d="M9 5.14286H5.14286V9H3.85714V5.14286H0V3.85714H3.85714V0H5.14286V3.85714H9V5.14286Z"></path>
                            </svg>
                          </span>
                        </div>
                        <span
                          id="qty47d74f9094122c6e2966d556b64a43bb_err"
                          style={{ color: "red" }}
                        ></span>
                      </div>
                    </td>
                    <td className="tf-cart-item_total" cart-data-title="Total">
                      <div className="cart-total">KWD 10.410</div>
                    </td>
                  </tr>
                  <tr className="tf-cart-item file-delete">
                    <td className="tf-cart-item_product">
                      <a
                        href="https://uat.webykw.com/product/dolce-and-gabbana-velvet-black-patchouli-7"
                        className="img-box"
                      >
                        <img
                          src="https://imgcdn.webykw.com/cdn-cgi/image/fit=cover,width=80,height=110/lolia/products/1726330311_d4c1288716e63e0b.jpg"
                          alt="Dolce & Gabbana Velvet Black Patchouli"
                        />
                      </a>
                      <div className="cart-info">
                        <a
                          href="https://uat.webykw.com/product/dolce-and-gabbana-velvet-black-patchouli-7"
                          className="cart-title link"
                        >
                          Dolce & Gabbana Velvet Black Patchouli
                        </a>
                        <div className="cart-meta-variant">
                          Select Option: 100ML
                          <br />
                        </div>
                        <span
                          className="remove-cart link remove"
                          onClick="remove('b69c609364b1a7cba3e3568d8f357368','2')"
                        >
                          Remove
                        </span>
                      </div>
                    </td>
                    <td className="tf-cart-item_price" cart-data-title="Price">
                      <div className="cart-price">KWD 120.750 </div>
                    </td>
                    <td
                      className="tf-cart-item_quantity"
                      cart-data-title="Quantity"
                    >
                      <div className="cart-quantity">
                        <div className="wg-quantity">
                          <span
                            className="btn-quantity"
                            id="down_b69c609364b1a7cba3e3568d8f357368"
                            onClick="checkQty('down','b69c609364b1a7cba3e3568d8f357368')"
                          >
                            <svg
                              className="d-inline-block"
                              width="9"
                              height="1"
                              viewBox="0 0 9 1"
                              fill="currentColor"
                            >
                              <path d="M9 1H5.14286H3.85714H0V1.50201e-05H3.85714L5.14286 0L9 1.50201e-05V1Z"></path>
                            </svg>
                          </span>
                          <input
                            type="text"
                            id="qtyb69c609364b1a7cba3e3568d8f357368"
                            value="1"
                            max="11"
                            readonly
                          />
                          <span
                            className="btn-quantity"
                            id="up_b69c609364b1a7cba3e3568d8f357368"
                            onClick="checkQty('up','b69c609364b1a7cba3e3568d8f357368')"
                          >
                            <svg
                              className="d-inline-block"
                              width="9"
                              height="9"
                              viewBox="0 0 9 9"
                              fill="currentColor"
                            >
                              <path d="M9 5.14286H5.14286V9H3.85714V5.14286H0V3.85714H3.85714V0H5.14286V3.85714H9V5.14286Z"></path>
                            </svg>
                          </span>
                        </div>
                        <span
                          id="qtyb69c609364b1a7cba3e3568d8f357368_err"
                          style={{ color: "red" }}
                        ></span>
                      </div>
                    </td>
                    <td className="tf-cart-item_total" cart-data-title="Total">
                      <div className="cart-total">KWD 120.750</div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="tf-page-cart-note">
                <label htmlFor="order_note">Add Order Note</label>
                <textarea
                  name="note"
                  id="order_note"
                  placeholder="How can we help you?"
                ></textarea>
              </div>
            </div>
            <div className="tf-page-cart-footer">
              <div className="tf-cart-footer-inner">
                <div className="tf-page-cart-checkout">
                  <div className="cart-checkbox">
                    <input
                      type="checkbox"
                      className="tf-check"
                      id="gift_wrap"
                      value="1"
                      defaultChecked
                    />
                    <label htmlFor="cart-gift-checkbox" className="fw-4">
                      <span>Do you want a gift wrap?</span> Only{" "}
                      <span className="fw-5">KWD 1.000</span>
                    </label>
                  </div>
                  <div id="cart_price_view">
                    <div className="tf-cart-totals-discounts">
                      <span>Item Total</span>
                      <span>KWD 131.160</span>
                    </div>
                    <div className="tf-cart-totals-discounts">
                      <span>Gift Wrap</span>
                      <span>KWD 1.000</span>
                    </div>
                    <div className="tf-cart-totals-discounts">
                      <h3>Sub Total</h3>
                      <span className="total-value">KWD 132.160</span>
                    </div>
                  </div>
                  <p className="tf-cart-tax">
                    <a href="https://uat.webykw.com/shipping-exchange">
                      Shipping
                    </a>
                    calculated at checkout{" "}
                  </p>
                  <div className="cart-checkout-btn">
                    <a
                      href="#login"
                      data-bs-toggle="modal"
                      className="tf-btn w-100 btn-fill animate-hover-btn radius-3 justify-content-center"
                    >
                      <span>Checkout</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cart;
